import { AbstractControl, ValidationErrors } from '@angular/forms';


export class ImportConfigValidators {
	static CronGroupValidator(control: AbstractControl): ValidationErrors | null {
		const interval = control.get('interval');
		const pattern = control.get('pattern');

		if (!interval || !pattern) {
			return null;
		}

		const valid = interval.value || pattern.value;

		if (!valid) {
			// Anything other than 'null' in setErrors marks this control as invalid
			// Providing {someKey:true} will print an error-message if a text is configured in inputErrorMessage-Pipe for the key 'someKey'
			// We don't want a text in this case - we just want to mark those controls as valid/invalid
			interval.setErrors({});
			pattern.setErrors({});
			return {cronNotFilled: true};
		}

		return null;
	}

	// Custom Required-Validator for different text
	static IdentifierValidator(control: AbstractControl): ValidationErrors | null {
		if (!control) {
			return null;
		}

		if (control.value) {
			control.setErrors(null);
			return null;
		} else {
			return {identifierMissing: true};
		}
	}
}
